import { render, staticRenderFns } from "./modal3.vue?vue&type=template&id=2d013468"
import script from "./modal3.vue?vue&type=script&lang=js"
export * from "./modal3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports